/*
 *
 * MeasurementDetails actions
 *
 */

import {
  GET_MEASURE_SIMPLE_WATCHER,
  GET_MEASURE_SIMPLE_SUCCESS,
  GET_MEASURE_SIMPLE_FAILED,
  UPDATE_MEASURE_WATCHER,
  UPDATE_MEASURE_SUCCESS,
  UPDATE_MEASURE_FAILED,
  REPROCESS_MEASURE_WATCHER,
  REPROCESS_MEASURE_SUCCESS,
  REPROCESS_MEASURE_FAILED
} from "./constants"



export function getMeasureSimpleWatcher(payload) {
  return {
    type: GET_MEASURE_SIMPLE_WATCHER,
    payload,
  }
}

export function getMeasureSimpleSuccess(payload) {
  return {
    type: GET_MEASURE_SIMPLE_SUCCESS,
    payload,
  }
}

export function getMeasureSimpleFailed(payload) {
  return {
    type: GET_MEASURE_SIMPLE_FAILED,
    payload,
  }
}

export function updateMeasureWatcher(payload) {
  return {
    type: UPDATE_MEASURE_WATCHER,
    payload,
  }
}

export function updateMeasureSuccess(payload) {
  return {
    type: UPDATE_MEASURE_SUCCESS,
    payload,
  }
}

export function updateMeasureFailed(payload) {
  return {
    type: UPDATE_MEASURE_FAILED,
    payload,
  }
}

export function reprocessMeasureWatcher(payload) {
  return {
    type: REPROCESS_MEASURE_WATCHER,
    payload,
  }
}

export function reprocessMeasureSuccess(payload) {
  return {
    type: REPROCESS_MEASURE_SUCCESS,
    payload,
  }
}

export function reprocessMeasureFailed(payload) {
  return {
    type: REPROCESS_MEASURE_FAILED,
    payload,
  }
}
